import { render, staticRenderFns } from "./userAddEdit.vue?vue&type=template&id=fb094e12&scoped=true&"
import script from "./userAddEdit.vue?vue&type=script&lang=js&"
export * from "./userAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./userAddEdit.vue?vue&type=style&index=0&id=fb094e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb094e12",
  null
  
)

export default component.exports